// Layout: Countdown
(function () {
    const PAD = (n) => String(Math.max(0, Math.floor(n))).padStart(2, "0");

    function computeUnits(msRemaining) {
        const totalSec = Math.max(0, Math.floor(msRemaining / 1000));
        const days = Math.floor(totalSec / 86400);
        const hours = Math.floor((totalSec % 86400) / 3600);
        const minutes = Math.floor((totalSec % 3600) / 60);
        const seconds = totalSec % 60;

        if (days >= 1) {
            return {
                values: [PAD(days), PAD(hours), PAD(minutes)],
                labels: ["DAYS", "HOURS", "MINUTES"],
            };
        }
        return {
            values: [PAD(hours), PAD(minutes), PAD(seconds)],
            labels: ["HOURS", "MINUTES", "SECONDS"],
        };
    }

    function swapValue(el, next) {
        if (el.textContent === next) return;
        el.classList.add("is-changing");
        setTimeout(() => {
            el.textContent = next;
            void el.offsetWidth;
            el.classList.remove("is-changing");
        }, 240);
    }

    function setLabel(el, next) {
        if (el.textContent === next) return;
        el.textContent = next;
    }

    function initCountdown(root) {
        const targetAttr = root.getAttribute("data-target");
        if (!targetAttr) return;
        const target = new Date(targetAttr).getTime();
        if (Number.isNaN(target)) return;

        const valueEls = root.querySelectorAll("[data-value]");
        const labelEls = root.querySelectorAll("[data-label]");
        if (valueEls.length !== 3 || labelEls.length !== 3) return;

        // Already past the target on page load — hide the clock immediately, no animation.
        if (target - Date.now() <= 0) {
            root.classList.add("is-expired");
            return;
        }

        let nextTickFlipsToSeconds = false;
        let timeoutId = null;

        function tick() {
            const remaining = target - Date.now();
            if (remaining <= 0) {
                root.classList.add("is-expired");
                if (timeoutId) clearTimeout(timeoutId);
                return true;
            }
            const { values, labels } = computeUnits(remaining);
            values.forEach((v, i) => swapValue(valueEls[i], v));
            labels.forEach((l, i) => setLabel(labelEls[i], l));
            nextTickFlipsToSeconds = labels[2] === "SECONDS";
            return false;
        }

        function reveal() {
            root.classList.add("is-ready");
            if (tick()) return;
            function schedule() {
                const delay = nextTickFlipsToSeconds ? 1000 : 30000;
                timeoutId = setTimeout(() => {
                    if (tick()) return;
                    schedule();
                }, delay);
            }
            schedule();
        }

        if ("IntersectionObserver" in window) {
            const io = new IntersectionObserver(
                (entries, obs) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            obs.disconnect();
                            reveal();
                        }
                    });
                },
                { threshold: 0.2 }
            );
            io.observe(root);
        } else {
            reveal();
        }
    }

    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll("[data-countdown]").forEach(initCountdown);
    });
})();
